<template>
  <div>
    <van-field
      :readonly="isDisabled"
      :label="title"
      :required="required"
      :placeholder="isDisabled ? '' : placeholder"
      :rightIcon="isDisabled ? '' : 'arrow'"
      v-model="realValue"
      @click="show"
      ref="input"
    />
    <div></div>
    <van-popup
      closeable
      v-model="visible"
      position="bottom"
      :style="{ height: height }"
      getContainer="#app"
    >
      <div class="popupContent">
        <van-button type="danger" size="mini" @click="clear" class="clearBtn"
          >清除</van-button
        >
        <van-search
          :placeholder="placeholder"
          v-model="searchValue"
          class="search"
        />
        <dataList
          ref="dataList"
          class="dataList"
          :api="api"
          :params="params"
          :pageField="pageField"
          :sizeField="sizeField"
          :dataField="dataField"
          :totalField="totalField"
          :pageStartIndex="pageStartIndex"
          :style="{ minHeight: 'calc( ' + height + ' - 105px)' }"
          :onOptionsLoadBefore="onOptionsLoadBefore"
          :onOptionsLoadAfter="onOptionsLoadAfter"
          :autoLoad="false"
        >
          <template v-slot="list">
            <div
              v-for="(item, index) in list"
              :key="index"
              @click="select(item, index)"
            >
              <slot name="default" :row="item" :index="index"></slot>
            </div>
          </template>
        </dataList>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { formSearchListConfig } from "@/components/base/conf";
import dataList from "@/components/base/dataList";
export default {
  name: "formSearchList",
  components: {
    dataList
  },
  props: {
    //值
    value: {
      type: [String, Number],
      default: ""
    },
    //标题
    title: {
      type: String,
      default: ""
    },
    //标题 宽度
    titleWidth: {
      type: String,
      default: ""
    },
    //api
    api: {
      type: Function,
      default: null
    },
    //请求参数
    param: {
      type: Object,
      default: () => ({})
    },
    //提示
    placeholder: {
      type: String,
      default: "请选择"
    },
    //必填
    required: {
      type: Boolean,
      default: false
    },
    //只读
    readonly: {
      type: Boolean,
      default: false
    },
    //禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //搜索按钮 描述
    searchBtnText: {
      type: String,
      default: "查询"
    },
    //高度
    height: {
      type: String,
      default: "65%"
    },
    //查询 参数对应值
    searchKeyField: {
      type: String,
      default: formSearchListConfig.searchKeyField
    },
    //显示值
    valueField: {
      type: String,
      default: formSearchListConfig.valueField
    },
    //页码参数
    pageField: {
      type: String,
      default: formSearchListConfig.pageField
    },
    //每页数量 参数
    sizeField: {
      type: String,
      default: formSearchListConfig.sizeField
    },
    //数据来源
    dataField: {
      type: String,
      default: formSearchListConfig.dataField
    },
    //页码参数来源
    totalField: {
      type: String,
      default: formSearchListConfig.totalField
    },
    //页码参数起始数
    pageStartIndex: {
      type: [Number, String],
      default: formSearchListConfig.pageStartIndex
    },
    // 可选数据请求前回调
    onOptionsLoadBefore: {
      type: Function,
      default: null
    },
    // 可选数据请求后回调
    onOptionsLoadAfter: {
      type: Function,
      default: null
    },
    //选中前回调
    onSelectBefore: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      params: { ...this.param, [this.searchKeyField]: "" },
      visible: false,
      searchValue: "",
      realValue: this.value
    };
  },
  computed: {
    isDisabled() {
      return this.disabled || this.readonly;
    }
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("input", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    },
    searchValue() {
      this.search();
    }
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    },
    /**
     * @description: 显示
     * @param {*}
     * @return {*}
     */
    show() {
      if (!this.isDisabled) {
        this.visible = true;
        this.$nextTick(() => {
          this.$refs.dataList.reload();
        });
      }
    },
    /**
     * @description: 搜索
     * @param {*}
     * @return {*}
     */
    search: debounce(function() {
      let { searchValue, param } = this;
      this.params = {
        ...param,
        [this.searchKeyField]: searchValue
      };
    }, 100),
    /**
     * @description: 清空
     * @param {*}
     * @return {*}
     */
    clear() {
      this.visible = false;
      this.$emit("change", null);
    },
    /**
     * @description: 选中
     * @param {*} row
     * @return {*}
     */
    select(row) {
      const { onSelectBefore } = this;
      if (onSelectBefore && onSelectBefore(row) === false) return;
      this.visible = false;
      this.realValue = row[this.valueField] || "";
      this.$emit("change", row);
    }
  }
};
</script>

<style lang="less" scoped>
.popupContent {
  padding-top: 50px;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .clearBtn {
    position: absolute;
    left: 15px;
    top: 15px;
  }
  .search {
    border-bottom: 1px solid #f1f1f1;
    /deep/&.van-search--show-action {
      padding-right: 12px;
    }
    /deep/.van-search__action {
      background: #1989fa;
      color: #fff;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .dataList {
    height: calc(65vh - 105px);
    overflow-x: hidden;
    overflow-y: auto;
    /deep/.van-cell {
      border-bottom: 1px solid @borderColor;
    }
  }
}
</style>
